import './Home.scss'
import { Button, Card, Col, Container, Row } from "reactstrap";
import { Link } from 'react-router-dom';
import { Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapLocation } from '@fortawesome/free-solid-svg-icons';

export type HomeParams = {
    full?: boolean,
    plusone?: boolean,
    post10?: boolean
}
export default function Home(params: HomeParams) {
    return (
        <div className="bg-home-image" style={{backgroundImage: "url('/img/header/marcosyclari-09.jpeg')"}}>
        <Container className="d-flex vh-100">
            <Row className="m-auto align-self-center">
                <Col>
                    <Card id='invitation'>
                            <Col>
                                <Row className='invitation-header'>
                                    <h2>¡Nos casamos!</h2>
                                </Row>
                                <Row className='invitation-text font-bold'>
                                    <p>{(params.full || params.plusone || params.post10) ? "Y queremos invitarte a festejar con nosotros este momento" : "Y queremos compartir con vos este momento"}</p>
                                </Row>
                                <Row>
                                    <Col md={(params.full || params.plusone || params.post10) ? 6 : 12}>
                                        <Row><h3>Ceremonia</h3></Row>
                                        <Row><div className='invitation-img rings' /></Row>
                                        <Row className='font-bold'>
                                            <p>24 de Octubre, 16:30</p>
                                            <p>Parroquia San Luis Gonzaga</p>
                                            <p>Primer Tte. D. Manzotti 149, Manzanares</p>
                                        </Row>
                                        <Row><a href='https://maps.app.goo.gl/ZLmZxVQk581g9jqL8' target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faMapLocation}/> Cómo llegar</a></Row>
                                    </Col>
                                    {(params.full || params.plusone) ? (<Col md={6}>
                                        <Row><h3>Fiesta</h3></Row>
                                        <Row><div className='invitation-img party'/></Row>
                                        <Row className='font-bold'>
                                            <p>24 de Octubre, 18:30</p>
                                            <p>Finca Madero - Salón El Roble</p>
                                            <p>Luis Jorge Fontana 900, Del Viso, Buenos Aires</p>
                                        </Row>
                                        <Row><a href='https://maps.app.goo.gl/yG5tCXVDGQkKzorZ9' target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faMapLocation}/> Cómo llegar</a></Row>
                                    </Col>) : (params.post10) ? (<Col md={6}>
                                        <Row><h3>Fiesta</h3></Row>
                                        <Row><div className='invitation-img party'/></Row>
                                        <Row className='font-bold'>
                                            <p>24 de Octubre, 21:30</p>
                                            <p>Finca Madero - Salón El Roble</p>
                                            <p>Luis Jorge Fontana 900, Del Viso, Buenos Aires</p>
                                        </Row>
                                        <Row><a href='https://maps.app.goo.gl/yG5tCXVDGQkKzorZ9' target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faMapLocation}/> Cómo llegar</a></Row>
                                    </Col>) : <Fragment />}
                                    
                                </Row>
                                <Row className='invitation-footer'>
                                    <Col md={(params.full || params.plusone || params.post10) ? 6 : 12} className="order-2 order-md-1">
                                        <h4>¿Querés hacernos un regalo?</h4>
                                        <Link to={"/gifts"}>
                                            <Button>Ver lista de regalos</Button>
                                        </Link>
                                    </Col>
                                    {params.full ? (<Col md={6} className="order-1 order-md-2">
                                        <h4>Confirmanos tu presencia:</h4>
                                        {/* RSVP de /fiesta: comida sin acompaniante */}
                                        <a href={"https://forms.gle/QsV2GzdoNd5gvBqc8"} target="_blank" rel="noreferrer">
                                            <Button>RSVP</Button>
                                        </a>
                                    </Col>) : params.plusone ? (
                                    <Col md={6} className="order-1 order-md-2">
                                        <h4>Confirmanos tu presencia:</h4>
                                        {/* RSVP de /fiesta!: comida con acompaniante */}
                                        <a href={"https://forms.gle/uPJsYB6ruDay1LBw9"} target="_blank" rel="noreferrer">
                                            <Button>RSVP</Button>
                                        </a>
                                    </Col>) : params.post10 ? (
                                    <Col md={6} className="order-1 order-md-2">
                                        <h4>Confirmanos tu presencia:</h4>
                                        {/* RSVP de /post: solo fiesta */}
                                        <a href={"https://forms.gle/BTuNRejMYt53CAdH7"} target="_blank" rel="noreferrer">
                                            <Button>RSVP</Button>
                                        </a>
                                    </Col>) : <Fragment />}
                                </Row>
                            </Col>
                    </Card>
                </Col>
            </Row>
        </Container>
        </div>
    )
}